import { ColDef, ISelectCellEditorParams } from 'ag-grid-community';
export const CategoryDetailsColumnDef: ColDef[] = [
  {
    headerName: '#',
    width: 90,
    rowDrag: true,
    valueGetter: function (params) {
      return +params.node.id + 1;
    },
  },
  {
    // Category
    headerName: 'Category',
    field: 'category',
    editable: true,
    resizable: true,
    width: 200,
    tooltipField: 'category',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [],
    } as ISelectCellEditorParams,
  },
  {
    // Description
    headerName: 'Description',
    field: 'description',
    editable: true,
    resizable: true,
    width: 400,
    flex: 1,
    tooltipField: 'description',
  },
  {
    // Amount
    headerName: 'Amount',
    field: 'amount',
    editable: true,
    resizable: true,
    width: 125,
    tooltipField: 'amount',
    valueFormatter: function(params) {
      if (params.value) {
        return '$' + Number(params.value).toFixed(2);
      } else {
        return null 
      }
    }
  },
];
export const ItemDetailsColumnDef: ColDef[] = [
  {
    headerName: '#',
    width: 90,
    rowDrag: true,
    valueGetter: function (params) {
      return +params.node.id + 1;
    },
  },
  {
    // ID
    headerName: 'id',
    field: 'id',
    editable: true,
    resizable: true,
    width: 200,
    hide: true,
  },
  {
    // Product/Service
    headerName: 'Product/Service',
    field: 'product_service',
    cellEditor: 'productServiceAutocomplete',
    editable: true,
    resizable: true,
    width: 200,
    tooltipField: 'product_service',
  },
  {
    // Description
    headerName: 'Description',
    field: 'description',
    editable: true,
    resizable: true,
    width: 400,
    flex: 1,
    tooltipField: 'description',
  },
  {
    // Qty
    headerName: 'Qty',
    field: 'qty',
    editable: true,
    resizable: true,
    width: 125,
    tooltipField: 'description',
    cellEditor: 'agNumberCellEditor',
    cellEditorParams: {
        precision: 0, // No decimal places (whole numbers only)
      }
  },
  {
    // Rate
    headerName: 'Rate',
    field: 'rate',
    editable: true,
    resizable: true,
    width: 125,
    valueFormatter: function(params) {
      if (params.value) {
        return '$' + Number(params.value).toFixed(2);
      } else {
        return null
      }
    }
  },
  {
    // Amount
    headerName: 'Amount',
    field: 'amount',
    editable: false,
    resizable: true,
    width: 125,
    valueFormatter: function(params) {
      if (params.value) {
        return '$' + Number(params.value).toFixed(2);
      } else {
        return null
      }
    }
  },
];
